<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Details"
              icon="fas fa-pen-to-square">
            </card-section-header>

            <div class="mb-2 animated fadeIn">
              <form [formGroup]="siteDetailsForm" (ngSubmit)="onSiteDetailsFormSubmit()">
                <div class="form-row">
                  <div class="col-md-5" style="margin-top: 27px;">
                    <div class="form-group">
                      <label>Name</label>
                      <input type="text" class="form-control" formControlName="name" placeholder="Enter site name">
                    </div>
                    <div class="form-group">
                      <label>Description</label>
                      <textarea type="text" class="form-control with-autoresize" appTextareaAutoresize formControlName="description"></textarea>
                    </div>
                    <div class="form-group" *ngIf="showWindFarmFields">
                      <label>Waypoint Interval (minutes)</label>
                      <input type="number" class="form-control" formControlName="waypointInterval">
                    </div>
                  </div>

                  <!-- Separator Column -->
                  <div class="col-md-1 d-flex justify-content-center">
                    <div style="border-left: 1px solid #DDDDDD; height: 100%;"></div>
                  </div>


                  <div class="col-md-4">
                    <h6 class="card-title">Contact Numbers</h6>
                    <div class="form-group">
                      <label>Main Contact Number</label>
                      <input type="text" class="form-control" formControlName="mainContactNumber" placeholder="">
                    </div>
                    <div class="form-group">
                      <label>Emergency Contact Number</label>
                      <input type="text" class="form-control" formControlName="emergencyContactNumber" placeholder="">
                    </div>
                    <div class="form-group">
                      <label>Regional Emergency Contact Number</label>
                      <input type="text" class="form-control" formControlName="altEmergencyContactNumber" placeholder="">
                    </div>
                  </div>
                </div>


                <div class="form-row">
                  <div class="col-md-4" *ngIf="!isSiteDelegate && availableInductions.length">
                    <div class="form-group">
                      <label>Site Induction</label>
                      <p-dropdown
                          class="pDropdownCustom"
                          [ngModel]="selectedInduction"
                          (ngModelChange)="onSelectedSiteInductionChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="availableInductions"
                          optionLabel="label"
                          placeholder="Choose An Induction"
                          filter="true">
                      </p-dropdown>

                      <button type="button" (click)="removeInduction()" class="btn btn-danger btn-link" *ngIf="!!selectedInduction">
                        remove induction
                      </button>
                    </div>
                  </div>

                </div>
                <br>
                <div class="form-row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-success btn-round">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
